<template>
  <el-dialog width="698px" title="生成激活码"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="generateAuthCodeVisible">
    <div class="details">

      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="license_id" label="产品名称">
              <el-input   v-model="productName" disabled  placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="date" label="本次授权截止时间">
              <el-date-picker
                v-model="currencyForm.date"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="list" label="必选模块">
              <el-checkbox-group v-model="currencyForm.module_require">
                <el-checkbox label="基础模块1" value="1"></el-checkbox>
                <el-checkbox label="基础模块2" value="2"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="list" label="可选模块">
              <el-checkbox-group v-model="currencyForm.module_optional">
                <el-checkbox label="基础模块1" value="1"></el-checkbox>
                <el-checkbox label="基础模块2" value="2"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">生成激活码</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { genLicenseCode} from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'generate_auth_code',
  props: {
    generateAuthCodeVisible: {
      type: Boolean,
      default: false,
    },
    licenseId: {
      type: Number,
      default: 0,
    },
    productName: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
       license_id: "",
       date:"",
       start_date: "",
       end_date: "",
       module_require:[],
       module_optional:[]
      },
      currencyFormRules:{
        license_id:[{ required: true, message: '请选择', trigger: 'change'}],
        date:[{ required: true, message: '请选择本次授权截止时间', trigger: 'change'}],
      },
    }
  },

  created() {
    if(this.licenseId){
      this.currencyForm.license_id = this.licenseId
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            license_id: this.currencyForm.license_id,
            start_date: this.currencyForm.date[0],
            end_date: this.currencyForm.date[1],
            module_require:this.currencyForm.module_require.join(','),
            module_optional:this.currencyForm.module_optional.join(','),
          }
          this.BtnDisabled = true
          genLicenseCode(postData).then(res => {
            if (res.code === 200) {
              this.BtnDisabled = false
              this.$emit('success',{product_name:this.productName,license_code:res.data.license_code})
              this.$emit('update:generateAuthCodeVisible', false)
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:generateAuthCodeVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
::v-deep .el-input-number{
  width: 100%;
  .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-date-editor--datetimerange{
  width: 100%;

}

</style>
